import React from 'react';
import './App.css';
import { BrowserRouter } from "react-router-dom";
import AppRoutes from './routes/routes';
import { UserProvider } from './context/UserContext';

function App() {
  return (
    <div className="App">
      <UserProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </UserProvider>
    </div>
  );
}

export default App;
